var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDealFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.599,
    height: 36.05,
    viewBox: "0 0 46.599 36.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "yellow-folders-11455",
    transform: "translate(0 -28.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161524",
    "data-name": "Path 161524",
    d: "M26.033,63.461a3.53,3.53,0,0,1-2.746-3.44h0a3.349,3.349,0,0,0-3.349-3.349H6.159A3.348,3.348,0,0,0,2.81,60.021V84.447A2.589,2.589,0,0,0,5.4,87.036H41.135a2.589,2.589,0,0,0,2.589-2.589V66.519a3.058,3.058,0,0,0-3.058-3.058Z",
    transform: "translate(-2.292 -22.879)",
    fill: "#27cda5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161525",
    "data-name": "Path 161525",
    d: "M64.308,61.8h2.061a2.589,2.589,0,0,0,2.589-2.589V41.285A3.058,3.058,0,0,0,65.9,38.227H51.267a3.53,3.53,0,0,1-2.746-3.44h0a3.349,3.349,0,0,0-3.349-3.349H31.393a3.349,3.349,0,0,0-3.349,3.349v1.3Z",
    transform: "translate(-22.876 -2.295)",
    fill: "#27cda5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161526",
    "data-name": "Path 161526",
    d: "M37.1,112.064H29.289a1.492,1.492,0,0,1-1.492-1.492v-3.115a1.492,1.492,0,0,1,1.492-1.492H37.1a1.492,1.492,0,0,1,1.492,1.492v3.115A1.492,1.492,0,0,1,37.1,112.064Z",
    transform: "translate(-22.675 -63.089)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161527",
    "data-name": "Path 161527",
    d: "M38.843,85.258H3.107A3.11,3.11,0,0,1,0,82.151V57.724a3.871,3.871,0,0,1,3.867-3.867H17.646a3.871,3.871,0,0,1,3.867,3.867A2.993,2.993,0,0,0,23.8,60.645H38.374a3.579,3.579,0,0,1,3.576,3.576V82.151A3.11,3.11,0,0,1,38.843,85.258ZM3.867,54.893a2.834,2.834,0,0,0-2.831,2.831V82.151a2.073,2.073,0,0,0,2.071,2.071H38.843a2.074,2.074,0,0,0,2.072-2.071V64.222a2.543,2.543,0,0,0-2.54-2.54H23.741a.5.5,0,0,1-.115-.013,4.024,4.024,0,0,1-3.149-3.944,2.835,2.835,0,0,0-2.831-2.832H3.867Z",
    transform: "translate(0 -20.582)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161528",
    "data-name": "Path 161528",
    d: "M64.075,60.026h-2.06a.518.518,0,0,1,0-1.036h2.06a2.073,2.073,0,0,0,2.071-2.071V38.99a2.543,2.543,0,0,0-2.54-2.54H48.972a.511.511,0,0,1-.115-.013,4.024,4.024,0,0,1-3.149-3.944,2.835,2.835,0,0,0-2.831-2.832H29.1a2.835,2.835,0,0,0-2.832,2.832v1.3a.518.518,0,1,1-1.036,0v-1.3A3.872,3.872,0,0,1,29.1,28.625H42.877a3.871,3.871,0,0,1,3.867,3.867,2.994,2.994,0,0,0,2.289,2.922H63.606a3.579,3.579,0,0,1,3.576,3.576V56.92A3.11,3.11,0,0,1,64.075,60.026Z",
    transform: "translate(-20.582 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161529",
    "data-name": "Path 161529",
    d: "M34.809,110.288H27a2.012,2.012,0,0,1-2.01-2.011v-3.115a2.012,2.012,0,0,1,2.01-2.01h7.813a2.012,2.012,0,0,1,2.01,2.01v3.115A2.012,2.012,0,0,1,34.809,110.288ZM27,104.188a.975.975,0,0,0-.974.974v3.115a.976.976,0,0,0,.974.975h7.813a.976.976,0,0,0,.974-.975v-3.115a.975.975,0,0,0-.974-.974Z",
    transform: "translate(-20.383 -60.795)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealFileIcon);
export default __webpack_public_path__ + "static/media/dealFileIcon.c05e82bf303260d18d1aab9ede825934.svg";
export { ForwardRef as ReactComponent };